<form id="payment-form" class="payer-block">
  <div class="form-group">
    <label class="form-label form-label--bold required" for="holderName">Name on card</label>
    <input
      type="text"
      class="form-control holder-name"
      [class]="{ 'error-input': showError && !(holderNameFormData$ | async).valid }"
      [(ngModel)]="holderName"
      placeholder="Cardholder Name"
      name="holderName"
      id="holderName"
    />
  </div>
  <label class="form-label form-label--bold required">Card</label>
  <div
    [id]="cardElementId"
    class="field"
    [class]="{ 'error-input': showError && !(cardFormData$ | async).valid }"
  ></div>
</form>
